/**
 * @Description
 */

import { FC, useEffect, useRef, useState } from 'react';
import { Switch } from 'antd';
import { surroundCompetitorsPagePOIDataList, famousBrandDataList, surroundCategoryPOIDataList, surroundCategorySharePOIDataList,
  surroundCompetitorsPageSharePOIDataList,
} from '@/common/api/siteselectionmap';
import { getAroundPage, getAroundPageShare } from '@/common/api/surround';
import { getDynamicDetail, getDynamicDetailShare } from '@/common/api/expandStore/chancepoint';
import { targetLegendIcon, detailTargetLegendIcon, targetMallShops, targetShops, targetSurrounding } from '../../ts-config';
import { isArray, isNotEmptyAny } from '@lhb/func';
import { useMethods } from '@lhb/hook';
import cs from 'classnames';
import styles from './index.module.less';
import { useBigdataFn } from '@/common/utils/bigdata';
import { getShopList, getShopListShare } from '@/common/api/expandStore/shop';

const LegendItem: FC<any> = ({
  item,
  legendData,
  detail,
  storeChecked,
  surroundingChecked,
  setStandardShopData,
  setChancepointData,
  setFamousBrandData,
  setCompetitorsData,
  setCommonStoreData,
  setCommonRimData,
  isOpenHeatMap,
  setIsOpenGatherClient,
  isShare,
  shareParams,
}) => {
  const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const storeParamsRef: any = useRef({});
  const surroundingParamsRef: any = useRef({});
  const [isChecked, setIsChecked] = useState<boolean>(false);
  const [loading, setIsLoading] = useState<boolean>(false);
  const [secondChange, setSecondChange] = useState<boolean>(false);
  const [updateCount, setUpdateCount] = useState<number>(0);

  useEffect(() => {
    const { key } = item || {};
    // 打开
    if (isChecked) {
      setIsLoading(true);
      switch (key) {
        case 'GATHER_CLIENT':
          setIsOpenGatherClient(true);
          setIsLoading(false);
          break;
        case 'STANDARD_SHOP':
        case 'MALL_STANDARD_SHOP':
          methods.loadStandardShopData();
          break;
        case 'MALL_CHANCE_POINT':
        case 'CHANCE_POINT':
          methods.loadChancepointData();
          break;
        case 'MALL_FAMOUS_BRAND': // 知名品牌
        case 'FAMOUS_BRAND':
          methods.loadFamousBrandData(item, 1, []);
          break;
        case 'MALL_COMPETITORS': // 竞品门店
        case 'COMPETITORS':
          methods.loadCompetitionData(item, 1, []);
          break;
        case 'RESTAURANT': // 餐饮
        case 'SHOPPING': // 购物
        case 'LIFE_SERVICE': // 生活服务
        case 'EDUCATION': // 教育培训
        case 'RECREATION': // 休闲娱乐
        case 'FITNESS': // 运动健身
        case 'HOTEL': // 酒店住宿
        case 'VEHICLE_SERVICE': // 汽车服务
        case 'MALL_RESTAURANT':
        case 'MALL_SHOPPING':
        case 'MALL_LIFE_SERVICE':
        case 'MALL_EDUCATION':
        case 'MALL_RECREATION':
        case 'MALL_FITNESS':
        case 'MALL_HOTEL':
        case 'MALL_VEHICLE_SERVICE':
          methods.loadCommonApiData(item, 1, []);
          break;
        case 'ZHU_ZHAI':
        case 'GOU_WU':
        case 'BAN_GONG':
        case 'XUE_XIAO':
        case 'YI_LIAO':
        case 'JIAO_TONG':
        case 'JING_QU':
          methods.loadCommonRimApiData(item, 1, []);
          break;
      }
      return;
    }
    methods.clearTargetData(key);
  }, [item, isChecked]);

  // 经营门店二级三级变化更新
  useEffect(() => {
    if (!isNotEmptyAny(storeParamsRef.current) || !secondChange) return;
    setSecondChange(false);
    const { key } = item || {};
    switch (key) {
      case 'MALL_FAMOUS_BRAND': // 知名品牌
      case 'FAMOUS_BRAND':
        if (storeChecked.filrstLevelCode !== 'FAMOUS_BRAND') return;
        methods.loadFamousBrandData(item, 1, []);
        break;
      case 'MALL_COMPETITORS': // 竞品门店
      case 'COMPETITORS':
        if (storeChecked.filrstLevelCode !== 'COMPETITION_BRAND') return;
        methods.loadCompetitionData(item, 1, []);
        break;
      case 'RESTAURANT': // 餐饮
      case 'SHOPPING': // 购物
      case 'LIFE_SERVICE': // 生活服务
      case 'EDUCATION': // 教育培训
      case 'RECREATION': // 休闲娱乐
      case 'FITNESS': // 运动健身
      case 'HOTEL': // 酒店住宿
      case 'VEHICLE_SERVICE': // 汽车服务
      case 'MALL_RESTAURANT':
      case 'MALL_SHOPPING':
      case 'MALL_LIFE_SERVICE':
      case 'MALL_EDUCATION':
      case 'MALL_RECREATION':
      case 'MALL_FITNESS':
      case 'MALL_HOTEL':
      case 'MALL_VEHICLE_SERVICE':
        methods.loadCommonApiData(item, 1, []);
        break;
    }
  }, [storeParamsRef.current, secondChange]);

  // 周边配套二级变化更新
  useEffect(() => {
    const { key } = item || {};
    // 打开
    if (isChecked) {
      switch (key) {
        case 'ZHU_ZHAI':
        case 'GOU_WU':
        case 'BAN_GONG':
        case 'XUE_XIAO':
        case 'YI_LIAO':
        case 'JIAO_TONG':
        case 'JING_QU':
          methods.loadCommonRimApiData(item, 1, []);
          break;
      }
      return;
    }
    methods.clearTargetData(key);
    // surroundingParamsRef.current 没啥卵用，加了updateCount是为了更新
  }, [surroundingParamsRef.current, updateCount]);

  useEffect(() => {
    if (!(isArray(legendData) && legendData.length)) return;
    if (!item) return;
    storeParamsRef.current = {}; // 先清空
    const {
      name,
      categoryId,
      filrstLevelCode, // 除了知名品牌、竞品，其他的类型的code
      secondLevelCode, // 二级分类code
      thirdLevelCode, // 年限
    } = storeChecked || {};
    if (item?.name === name) {
      categoryId && (storeParamsRef.current.categoryId = categoryId);
      filrstLevelCode && (storeParamsRef.current.filrstLevelCode = filrstLevelCode);
      secondLevelCode && (storeParamsRef.current.secondLevelCode = secondLevelCode);
      thirdLevelCode && (storeParamsRef.current.thirdLevelCode = thirdLevelCode);
      setIsChecked(true);
      setSecondChange(true);
      if (!item.handSwitch) { // 如果手动打开过
        item.handSwitch = false;
      }
      item.automaticSwitch = true;
      return;
    }
    // 关掉不是手动打开的
    legendData.forEach((legendItem: any) => {
      const { handSwitch, automaticSwitch, key } = legendItem;
      if ((targetMallShops.includes(key) || targetShops.includes(key)) && !handSwitch && automaticSwitch && key === item.key) {
        setIsChecked(false);
        methods.clearTargetData(key);
      }
    });
  }, [legendData, storeChecked]);
  useEffect(() => {
    if (!(isArray(legendData) && legendData.length)) return;
    if (!item) return;
    surroundingParamsRef.current = {}; // 先清空
    const { name, aoiTypeCategoryId, secondAoiType } = surroundingChecked || {};
    if (item?.name === name) {
      aoiTypeCategoryId && (surroundingParamsRef.current.aoiTypeCategoryId = aoiTypeCategoryId); // 一级
      secondAoiType && (surroundingParamsRef.current.secondAoiType = secondAoiType); // 二级
      setUpdateCount((state) => (state + 1));
      setIsChecked(true);
      if (!item.handSwitch) { // 如果手动打开过
        item.handSwitch = false;
      }
      item.automaticSwitch = true;
      return;
    }
    // 关掉不是手动打开的
    legendData.forEach((legendItem: any) => {
      const { handSwitch, automaticSwitch, key } = legendItem;
      if (targetSurrounding.includes(key) && !handSwitch && automaticSwitch && item.key === key) {
        setIsChecked(false);
        methods.clearTargetData(key);
      }
    });
  }, [legendData, surroundingChecked]);
  const methods = useMethods({
    handleChange: (checked: boolean) => {
      setIsChecked(checked);
      // 通知
      item.handSwitch = checked;
      item.automaticSwitch = false;
      bigdataFn('50194f70-7037-4cc0-8c5f-aeb18fc2b614', '详情-地图-图例开关', '点击了详情-地图-图例开关', { op_block: '开店区域-详情页', op_event: ``, });
    },

    loadStandardShopData: async () => {
      if (!detail?.id) return;
      try {
        const targetFetch = isShare && (!shareParams?.token) ? getShopListShare : getShopList;
        const targetData = await targetFetch({
          page: 1,
          size: 50, // 500内机会点不会很多
          modelClusterId: detail?.id,
          noDataPermission: true,
          ...(shareParams?.tenantId ? { tenantId: shareParams.tenantId, isShare: !shareParams?.token } : {}),
          ...(shareParams?.employeeId ? { userId: shareParams.employeeId } : {}),
        });
        const { objectList } = targetData || {};
        setStandardShopData(isArray(objectList) ? objectList : []);
      } catch (error) {};
      setIsLoading(false);
    },

    loadChancepointData: async () => {
      if (!detail?.id) return;
      try {
        const targetFetch = isShare && (!shareParams?.token) ? getDynamicDetailShare : getDynamicDetail;
        const targetData = await targetFetch({
          page: 1,
          size: 50, // 500内机会点不会很多
          modelClusterId: detail?.id,
          dynamicTemplateType: 2, // 动态表头模版类型 ： 1：机会点， 2:选址地图商圈  默认1
          distance: item?.distance || 500,
          longitude: detail?.lng,
          latitude: detail?.lat,
          ...(shareParams?.tenantId ? { tenantId: shareParams.tenantId } : {}),
          ...(shareParams?.employeeId ? { userId: shareParams.employeeId } : {}),
        });
        const { objectList } = targetData || {};
        setChancepointData(isArray(objectList) ? objectList : []);
      } catch (error) {};
      setIsLoading(false);
    },
    loadFamousBrandData: async (target: any, page, lastData) => {
      const sizeVal = 100;
      // 用户关闭弹窗的时候数据还在请求下一页
      if (!detail?.cityId) return;
      try {
        const { objectList, totalNum } = await famousBrandDataList({
          page,
          size: sizeVal,
          cityId: detail?.cityId,
          lng: detail?.lng,
          lat: detail?.lat,
          radius: target.distance,
          clusterId: detail?.id,
          ...(storeParamsRef.current ? storeParamsRef.current : {}), // categoryId
        }, {
          needCancel: false
        });
        const targetData = isArray(objectList) ? objectList : [];
        const totalData = [...lastData, ...targetData];

        // 返回的数据等于size，说明可能还有下一页
        if (targetData.length === sizeVal && totalData.length < totalNum) {
          methods.loadFamousBrandData(target, page + 1, [...lastData, ...targetData]);
        } else {
          setFamousBrandData(totalData);
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
      }
    },
    loadCompetitionData: async (target: any, page, lastData) => {
      const sizeVal = 200;
      if (!detail?.cityId) return;
      try {
        const targetFetch = isShare && (!shareParams?.token) ? surroundCompetitorsPageSharePOIDataList : surroundCompetitorsPagePOIDataList;
        const { objectList, totalNum } = await targetFetch({
          page,
          size: sizeVal,
          lng: detail?.lng,
          lat: detail?.lat,
          cityId: detail?.cityId,
          radius: target.distance,
          clusterId: detail?.id,
          ...(shareParams?.tenantId ? { tenantId: shareParams.tenantId } : {}),
          ...(shareParams?.employeeId ? { userId: shareParams.employeeId } : {}),
        }, {
          needCancel: false
        });
        const targetData = isArray(objectList) ? objectList : [];
        const totalData = [...lastData, ...targetData];
        // 返回的数据等于size，说明可能还有下一页
        if (targetData.length === sizeVal && totalData.length < totalNum) {
          methods.loadCompetitionData(target, page + 1, totalData);
        } else {
          setCompetitorsData(totalData);
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
      }
    },
    loadCommonApiData: async (target: any, page, lastData) => {
      const sizeVal = 200;
      if (!detail?.id) return;
      try {
        const targetFetch = isShare && (!shareParams?.token) ? surroundCategorySharePOIDataList : surroundCategoryPOIDataList;
        const { objectList, totalNum } = await targetFetch({
          page,
          size: sizeVal,
          clusterId: detail?.id,
          filrstLevelCode: target.code,
          ...(storeParamsRef.current ? storeParamsRef.current : {}), // 一二三级code
          ...(shareParams?.tenantId ? { tenantId: shareParams.tenantId } : {}),
          ...(shareParams?.employeeId ? { userId: shareParams.employeeId } : {}),
        }, {
          needCancel: false
        });
        const targetData = isArray(objectList) ? objectList : [];
        const totalData = [...lastData, ...targetData];
        // 返回的数据等于size，说明可能还有下一页
        if (targetData.length === sizeVal && totalData.length < totalNum) {
          methods.loadCommonApiData(target, page + 1, totalData);
        } else {
          setCommonStoreData((state) => ({ ...state, [target.key]: totalData }));
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
      }
    },
    loadCommonRimApiData: async (target: any, page, lastData) => {
      const sizeVal = 200;
      if (!detail?.cityName) return;
      try {
        const targetFeatch = isShare && (!shareParams?.token) ? getAroundPageShare : getAroundPage;
        const { objectList, totalNum } = await targetFeatch({
          page,
          size: sizeVal,
          aoiTypeCategoryId: target.aoiTypeCategoryId,
          lng: detail?.lng,
          lat: detail?.lat,
          radius: target?.distance || null, // 接口要求没值传null
          cityName: detail?.cityName,
          // distance有值是poiSearchType传1，否则传null
          poiSearchType: target.distance ? 1 : null,
          ...(surroundingParamsRef.current ? surroundingParamsRef.current : {}), // 一二三级code
          ...(shareParams?.tenantId ? { tenantId: shareParams.tenantId } : {}),
          ...(shareParams?.employeeId ? { userId: shareParams.employeeId } : {}),
        }, {
          needCancel: false
        });
        const targetData = isArray(objectList) ? objectList : [];
        const totalData = [...lastData, ...targetData];
        // 返回的数据等于size，说明可能还有下一页
        if (targetData.length === sizeVal && totalData.length < totalNum) {
          methods.loadCommonRimApiData(target, page + 1, totalData);
        } else {
          setCommonRimData((state) => ({ ...state, [target.key]: totalData }));
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
      }
    },
    clearTargetData: (key: string) => {
      // 关闭-清空对应数据
      switch (key) {
        case 'GATHER_CLIENT':
          setIsOpenGatherClient(false);
          break;
        case 'STANDARD_SHOP':
        case 'MALL_STANDARD_SHOP':
          setStandardShopData([]);
          break;
        case 'CHANCE_POINT':
        case 'MALL_CHANCE_POINT':
          setChancepointData([]);
          break;
        case 'MALL_FAMOUS_BRAND': // 知名品牌
        case 'FAMOUS_BRAND':
          setFamousBrandData([]);
          break;
        case 'MALL_COMPETITORS': // 竞品门店
        case 'COMPETITORS':
          setCompetitorsData([]);
          break;
        case 'RESTAURANT': // 餐饮
        case 'SHOPPING': // 购物
        case 'LIFE_SERVICE': // 生活服务
        case 'EDUCATION': // 教育培训
        case 'RECREATION': // 休闲娱乐
        case 'FITNESS': // 运动健身
        case 'HOTEL': // 酒店住宿
        case 'VEHICLE_SERVICE': // 汽车服务
        case 'MALL_RESTAURANT':
        case 'MALL_SHOPPING':
        case 'MALL_LIFE_SERVICE':
        case 'MALL_EDUCATION':
        case 'MALL_RECREATION':
        case 'MALL_FITNESS':
        case 'MALL_HOTEL':
        case 'MALL_VEHICLE_SERVICE':
          setCommonStoreData((state) => ({
            ...state,
            [key]: []
          }));
          break;
        case 'ZHU_ZHAI':
        case 'GOU_WU':
        case 'BAN_GONG':
        case 'XUE_XIAO':
        case 'YI_LIAO':
        case 'JIAO_TONG':
        case 'JING_QU':
          setCommonRimData((state) => ({
            ...state,
            [key]: []
          }));
          break;
      }
    }
  });
  return (
    <div className={styles.legendItemCon}>
      <div className={styles.iconCon}>
        <img
          src={detailTargetLegendIcon[item?.key] || targetLegendIcon[item?.key]}
          alt='icon'
          width='100%'
        />
      </div>
      <div className={cs(styles.nameCon, 'c-333 fs-12')}>
        {item?.name}
        {
          item?.distanceStr ? <>({item.distanceStr})</> : <></>
        }
      </div>
      <div>
        <Switch
          disabled={isOpenHeatMap}
          checked={isChecked}
          loading={loading}
          size='small'
          onChange={methods.handleChange}
        />
      </div>
    </div>
  );
};

export default LegendItem;
